import { Types } from '@store/types';

export const onTogglePrice = (value) => async (dispatch) => {
	dispatch({
		type: Types.SET_TOGGLE_PRICE,
		payload: value
	});
};
